import { z } from 'zod';

import { ConditionViolationSchema } from './condition-violation';
import {
  UnitOverviewColumnConfigSchema,
  UnitOverviewRowSchema,
} from './overview';
import { WarrantyPenaltySchema } from './warranty-penalty';

export const DataResultSchema = z.object({
  unitOverview: z.object({
    columns: z.array(UnitOverviewColumnConfigSchema),
    rows: z.array(UnitOverviewRowSchema),
  }),
  warrantyPenalties: z.array(WarrantyPenaltySchema),
  conditionViolations: z.array(ConditionViolationSchema),
});

export type DataResult = z.infer<typeof DataResultSchema>;
